// import conf from '../../../config/vue/config.js';
import Keycloak from 'keycloak-js';
import $ from 'jquery';
import {LeanbotSleep} from "../../js/api/util"
import {asyncScheduler,BehaviorSubject, delay, filter, retryWhen,  tap, from, concatMap, Subject, delayWhen, timer, defer, retry} from "rxjs"
/* eslint-disable */

interface IMessageSocket {
	messageType:string;
	data:any;
}

export  class WebsocketLeanbot {
	connect=new BehaviorSubject<WebSocket>(null);
	queue: Promise<boolean>;
	events: {eventname:string;callback:(e:any)=>void}[];
	messages=new Subject<IMessageSocket>();
	conns:any[]=[];
	sendQueue$ = new Subject<any>();
	
	

	
	
    constructor() {
		this.queue=Promise.resolve(true);
		this.events=[];

		this.sendQueue$
		.pipe(
		  concatMap((data) =>
			defer(()=>from(this.sendUntilAck(data))).pipe(
				retry({
					count:5,
					delay:300	
				})
			)
		  )
		)
		.subscribe({
		  next: (res) => console.log("✅ Sent:", res),
		  error: (err) => console.error("❌ Unhandled error:", err),
		});
	}
	on(eventname:string,callback:(p:any)=>void){
		this.messages.pipe(filter(msg=>msg.messageType==eventname))
		.subscribe((d)=>callback(d.data))
		// this.events.push({eventname,callback})
	}

	// private _handleEvent(type:string,data:any) {
	// 	this.events.filter(o=>o.eventname==type).forEach((e)=>{
	// 		asyncScheduler.schedule(()=>e.callback(data))
	// 	})
	// } 
	createNewConnection() {
	
		var socket=new WebSocket(conf.websocket.url);
		// console.log("createNewConnection",socket);
		var p1=new Promise((re1,rej1)=>{
			socket.onclose=(e)=>{
				this.messages.next({messageType: "close",data:e});
				rej1();
			}
			this.connect.next(socket);
			socket.onmessage=(message)=>{
				this.messages.next({messageType: "message",data:message});
			}
			socket.onerror=()=>{
				rej1();
			}
			socket.onopen=(e)=>{
				this.messages.next({messageType: "open",data:e});
				this.conns.push(socket);
				// re1(true);
			}
		}).catch(e=>{
			try{
				socket.close();
			}catch{}
			asyncScheduler.schedule(()=>{
				this.createNewConnection();
			},500)
			
		})
		return p1;
			
		
		
	}
	async init(onMessageFunc?:(...args:any)=>void){
		this.createNewConnection();
		this.setUpPing();
		if (onMessageFunc) {
			this.on("message",onMessageFunc)
		}
		return;
		
		
    }
	setUpPing() {
		var me=this;
		var conn:WebSocket;
		this.connect.subscribe(c=>{
			conn=c;
		})
		asyncScheduler.schedule(function(){
			try {
				if (conn && conn.readyState === WebSocket.OPEN) {
					conn.send(JSON.stringify({data:"ping",mode:"ping"}));
					// console.log("pinging server");
				}
			}catch(ex) {
				console.error("ping server error");
			}
			// console.log("ping")
			this.schedule(null,1000); 
		})
		
		
	}
	sendUntilAck=(data:any)=> {
		var me=this;
		return new Promise(async (resolve, reject) => {
			var conn:WebSocket=this.conns[this.conns.length-1];
			// console.log("conn",conn,conn.readyState);
			// var done=false;
			if (conn && conn.readyState == WebSocket.OPEN) {
				try {
					conn.send(data);
					// console.log("send success",data);
					// done=true;
					resolve(data);
					return;
				}catch(e) {
					// console.log("send failed",e);
					return reject(new Error("WebSocket not open"));
				}
			}
			// await this.createNewConnection();
			// console.log("createNewConnection success");
			return reject(new Error("WebSocket not open"));
	
		});
	  }
    
   	// async reconnect(){
	// 	this.init(leanbotWebsocketReConnect);
			
	// }
	private retryUtilSucess(data:any) {
		var me=this;
		return new Promise<boolean>(resolve=>{
			asyncScheduler.schedule(function(){
				var conn:WebSocket=me.conns[me.conns.length-1];
				console.log("conn",conn);
				// var done=false;
				if (conn && conn.readyState == WebSocket.OPEN) {
					try {
						conn.send(data);
						// done=true;
						resolve(true);
						return;
					}catch(e) {
						console.error("send failed",e)
					}
				}
				
					console.warn("retry send data to the gateway")
					this.schedule(null,100)
				
			})
			
		}).catch(e=>{
			return false;
		})
	}
	async send(data:any){
	
		// console.log("send to websocket",data);
		this.sendQueue$.next(data);
		return Promise.resolve(true);
		this.queue=this.queue.then(()=>{
			return this.retryUtilSucess(data);
		})
		return await this.queue;
		
	}
	
}
export default WebsocketLeanbot;
	
// export function leanbotWebsocketReConnect(e){
// 	console.log(e);
// }
	
// function LeanbotSleep(ms) {
//       return new Promise(resolve => setTimeout(resolve, ms));
//   }





